import React, { useState, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { FreeMode, Autoplay, Controller } from "swiper"
import type { Occasion } from "./App"
import { formatPrice } from "./util"

SwiperCore.use([FreeMode, Autoplay])

export default function Item({ occasion }: { occasion: Occasion }) {
    const [currentlyHovered, setCurrentlyHovered] = useState<boolean>(false)
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore | null>(
        null
    )

    useEffect(() => {
        swiperInstance?.autoplay.stop()
    }, [swiperInstance])

    useEffect(() => {
        swiperInstance?.autoplay.stop()
        if (currentlyHovered) {
            swiperInstance?.autoplay.start()
        }
    }, [currentlyHovered])

    return (
        <a
            href={occasion.url}
            target="_blank"
            onMouseEnter={() => setCurrentlyHovered(true)}
            onMouseLeave={() => setCurrentlyHovered(false)}
            className="shadow flex flex-col text-dark"
            key={occasion.id}
        >
            <div className="relative">
                <img
                    className="w-full sm:h-[200px] h-[125px] object-cover"
                    src={
                        occasion.featured_image
                            ? occasion.featured_image
                            : `${window.local_occasions_object.asset}/placeholder.svg`
                    }
                    alt={occasion.title}
                />

                <div className="price absolute bottom-4 left-4 bg-primary text-white font-bold text-light px-5 py-2 leading-none">
                    <span className="relative top-[1px]">
                        {!occasion.is_sold
                            ? `€${formatPrice(parseInt(occasion.price))}`
                            : `Verkocht`}
                    </span>
                </div>
            </div>

            <div className="p-5 flex flex-col">
                <span className="sm:text-lg text-sm font-bold">
                    {occasion.title}
                </span>

                <hr className="w-[48px] bg-primary h-[2px] my-3" />

                {window.local_occasions_object.is_corporate && (
                    <div className="flex items-center mb-4">
                        <img
                            className="mr-2"
                            src={`${window.local_occasions_object.asset}/pin.svg`}
                            alt="Pin"
                        />
                        {occasion.supplier.name}
                    </div>
                )}

                <Swiper
                    spaceBetween={10}
                    slidesPerView={"auto"}
                    freeMode
                    onSwiper={(instance) => setSwiperInstance(instance)}
                    modules={[Controller]}
                    autoplay={{
                        delay: 1000,
                        disableOnInteraction: false,
                    }}
                    className="w-full lg:text-base text-xs"
                >
                    <SwiperSlide className="px-3 py-1 bg-grey text-[#8C8C8C] w-auto select-none cursor-move ">
                        {occasion.kilometers} km
                    </SwiperSlide>
                    <SwiperSlide className="px-3 py-1 bg-grey text-[#8C8C8C] w-auto select-none cursor-move">
                        {occasion.year}
                    </SwiperSlide>
                    {occasion.transmission && (
                        <SwiperSlide className="px-3 py-1 bg-grey text-[#8C8C8C] w-auto select-none cursor-move">
                            {occasion.transmission.name}
                        </SwiperSlide>
                    )}
                    {occasion.fuel && (
                        <SwiperSlide className="px-3 py-1 bg-grey text-[#8C8C8C] w-auto select-none cursor-move">
                            {occasion.fuel.name}
                        </SwiperSlide>
                    )}

                    {occasion.type && (
                        <SwiperSlide className="px-3 py-1 bg-grey text-[#8C8C8C] w-auto select-none cursor-move">
                            {occasion.type.name}
                        </SwiperSlide>
                    )}

                    <SwiperSlide className="px-3 py-1 bg-grey text-[#8C8C8C] w-auto select-none cursor-move">
                        {occasion.power} kw
                    </SwiperSlide>
                </Swiper>
            </div>
        </a>
    )
}
